import { TABLE_REPORTE_ESTADO_POR_SECTOR_DOS,
  TABLE_REPORTE_ESTADO_POR_SECTOR_UNO,
  TABLE_REPORTE_ESTADO_POR_SECTOR_TRES,
  TABLE_REPORTE_ESTADO_POR_SECTOR_CUATRO,
  TABLE_REPORTE_ESTADO_POR_SECTOR_CINCO,
  TABLE_TOTAL_ESTADO_POR_SECTOR_UNO,
  TABLE_TOTAL_ESTADO_POR_SECTOR_DOS,
  TABLE_TOTAL_ESTADO_POR_SECTOR_TRES,
  TABLE_TOTAL_ESTADO_POR_SECTOR_CUATRO,
  TABLE_TOTAL_ESTADO_POR_SECTOR_CINCO
} from '../../../config/tables'
import { ReporteEstadoPorSiloService } from '../../../models/ReportePorSector/ReportePorSectorService'
import { ReporteEstadoPorSiloUtils } from '../../../models/ReportePorSector/ReportePorSectorUtils'
import { COLUMNS, COLUMNS_TOTALES } from './constantesTablaReportePorSector'

export function fetchSectores () {
  return async dispatch => {
    const tabla = [
      TABLE_REPORTE_ESTADO_POR_SECTOR_UNO,
      TABLE_REPORTE_ESTADO_POR_SECTOR_DOS,
      TABLE_REPORTE_ESTADO_POR_SECTOR_TRES,
      TABLE_REPORTE_ESTADO_POR_SECTOR_CUATRO,
      TABLE_REPORTE_ESTADO_POR_SECTOR_CINCO
    ]
    const tablaTotales = [
      TABLE_TOTAL_ESTADO_POR_SECTOR_UNO,
      TABLE_TOTAL_ESTADO_POR_SECTOR_DOS,
      TABLE_TOTAL_ESTADO_POR_SECTOR_TRES,
      TABLE_TOTAL_ESTADO_POR_SECTOR_CUATRO,
      TABLE_TOTAL_ESTADO_POR_SECTOR_CINCO
    ]
    for (let i = 1; i <= 5; i++) {
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          isLoading: true
        },
        id: tabla[i - 1]
      })
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          isLoading: true
        },
        id: tablaTotales[i - 1]
      })
    }
    const parsedData = []
    const parsedDataTotales = []
    for (let i = 1; i <= 5; i++) {
      console.log('sector', i)
      const dataSilos = await ReporteEstadoPorSiloService.getReporte(i)
      console.log('data silos', dataSilos)
      const dataTotales = await ReporteEstadoPorSiloService.getReporteDeSector(i)
      console.log('data totales', dataTotales)
      parsedDataTotales[i] = dataTotales
      parsedData[i] = ReporteEstadoPorSiloUtils.parseDataCombinada(dataSilos, dataTotales)
      console.log('data parseada', parsedData[i])
      console.log('totales parseada', parsedDataTotales[i])
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS,
          data: parsedData[i],
          title: `Reporte detallado de Estado por Sector ${i}`,
          isLoading: false,
          extraOptions: {
            pagination: false
          }
        },
        id: tabla[i - 1]
      })
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_TOTALES,
          data: parsedDataTotales[i].filas,
          title: `Totales por Sector ${i}`,
          isLoading: false,
          extraOptions: {
            customToolbar: null,
            print: false,
            pagination: false,
            download: false,
            filter: false,
            search: false,
            viewColumns: false
          }
        },
        id: tablaTotales[i - 1]
      })
    }
  }
}
